import { Card, CardBody, TrackScrolledIntoView } from '@homebotapp/hb-react-component-catalog'
import { Info } from './Info'
import { defineMessages } from 'react-intl'
import { ExtraPrincipalPayments } from './ExtraPrincipalPayments'
import { HOMEOWNER_DIGEST_EXTRA_PAYMENTS_MODULE } from '../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MSG = defineMessages({})

export interface ExtraPaymentsModuleProps {
  withCurrentHomeData: boolean
}

export const ExtraPaymentsModule = ({ withCurrentHomeData }: ExtraPaymentsModuleProps) => {
  return (
    <TrackScrolledIntoView
      tracking={{
        guid: 'dG9eSoj1H7M5ZLbhTdqhWt',
        ui_context: HOMEOWNER_DIGEST_EXTRA_PAYMENTS_MODULE,
        descriptor: 'Extra Payments Module scrolled into view'
      }}
    >
      <Card size='lg'>
        <CardBody>
          <ExtraPrincipalPayments withCurrentHomeData={withCurrentHomeData} />
          <Info withCurrentHomeData={withCurrentHomeData} />
        </CardBody>
      </Card>
    </TrackScrolledIntoView>
  )
}
